function jobFileManager() {
	const config = {childList: true, subtree: true};
	const targetElements = document.getElementsByClassName('upload-form-wrapper');
	if (targetElements.length > 0) {
		const mutationObserver = new MutationObserver(mutations => {
			for (let mutation of mutations) {
				const nodesToProcess: Node[] = [];
				for (let i = 0; i < mutation.addedNodes.length; i++) {
					const addedNodesI = mutation.addedNodes[i];
					if (addedNodesI instanceof Element) {
						if ((addedNodesI as Element).classList.contains('amazon-file-upload')) {
							nodesToProcess.push(addedNodesI);
						} else {
							const children = (addedNodesI as Element).querySelectorAll('.amazon-file-upload');
							if (children.length > 0) {
								(window as any).plauditUI.fileUploader(children);
							}
						}
					}
				}
				(window as any).plauditUI.fileUploader(nodesToProcess);
			}
		});
		for (let i = 0; i < targetElements.length; i++) {
			mutationObserver.observe(targetElements.item(i), config);
		}
	}
}

export default jobFileManager;
